// FormikTextareaFieldArray.js
import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";

const FormikTextareaFieldArray = ({ name, ...rest }) => (
  <>
    <Field as="textarea" name={name} {...rest} />
    <ErrorMessage component="div" className="text-danger" name={name} />
  </>
);

FormikTextareaFieldArray.propTypes = { name: PropTypes.string.isRequired };
export default FormikTextareaFieldArray;
